module.exports = __webpack_public_path__ + "img/icon_service.91268b44.png";